'use client'

import { useProdToken } from '~/lib/hooks'

function ProdSession() {
  useProdToken()

  return null
}

export default ProdSession
